import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InstructorLayout from "../../layouts/InstructorLayout";
import {
  useGetAllCourseModuleUserSideQuery,
  useGetCourseByIdQuery,
  useGetInstructorSessionStudentsQuery,
} from "../../services/instructor/instructor";
import { ChevronLeft } from "lucide-react";
const Stat = ({ value, name }) => (
  <div>
    <h3 className="text-xl leading-8  text-[#1D2026] mb-1">{value}</h3>

    <p className="text-[#6E7485] text-sm uppercase leading-[22px]">{name}</p>
  </div>
);
const CourseDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useGetCourseByIdQuery(id);
  const course = data?.data || [];

  const { data: modulesData } = useGetAllCourseModuleUserSideQuery(id);
  const { data: sessionStudentsData } = useGetInstructorSessionStudentsQuery(
    id,
    { skip: !id },
  );

  const modules = modulesData?.data || [];
  const sessionStudents = (sessionStudentsData?.data || []).filter(
    (student) => student?._id,
  );
  const creator = course?.createdBy;
  const creatorName = [creator?.firstName, creator?.lastName]
    .filter(Boolean)
    .join(" ");
  const creatorImage =
    creator?.profilePicture?.secureUrl || creator?.profilePicture;
  const creatorInitials = [creator?.firstName?.[0], creator?.lastName?.[0]]
    .filter(Boolean)
    .join("")
    .toUpperCase();
  return (
    <InstructorLayout>
      <div className="bg-[#D9D9D926] min-h-screen px-6 xl:px-10 py-6">
        {isLoading ? (
          <div className="flex items-center justify-center h-[70vh]">
            <div className="w-12 h-12 border-4 border-[#089BC4] border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <>
            <div className="flex ml-1 items-center gap-3 text-sm mb-3">
              <span className="text-[#6E7485]">My Courses</span>

              <span className="text-[#6E7485]">/</span>

              <span className="text-[#1D2026] ">{course?.courseTitle}</span>
            </div>

            <button onClick={() => navigate(-1)} className="mb-6">
              <ChevronLeft size={30} className="text-[#089BC4]" />
            </button>

            <div className="bg-[#F4F4F4] px-4 pt-7 pb-10">
              <div className="flex  gap-6">
                <div className="w-[383px] h-[305px]">
                  <img
                    src={course?.courseThumbnail?.secureUrl}
                    alt="Course"
                    className="w-full h-full  object-cover rounded-[32px]"
                  />
                </div>

                <div className="flex-1 font-['Inter']">
                  <div className="flex flex-col xl:flex-row  xl:items-center gap-4 leading-4 text-[#8C94A3] text-xs mb-3">
                    <p>
                      Uploaded:{" "}
                      <span className="text-[#4E5566]">
                        {new Date(course?.createdAt).toLocaleDateString(
                          "en-US",
                          {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          },
                        )}
                      </span>
                    </p>

                    <p>
                      Last Updated:{" "}
                      <span className="text-[#4E5566]">
                        {new Date(course?.updatedAt).toLocaleDateString(
                          "en-US",
                          {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          },
                        )}
                      </span>
                    </p>
                  </div>

                  <h1 className="text-xl leading-[26px] font-semibold text-[#1D2026] mb-2">
                    {course?.courseTitle}
                  </h1>
                  <p className="text-sm text-[#6E7485] leading-[22px]">
                    {course?.courseSubCategory}
                  </p>

                  <div className="flex items-center gap-3 mt-4 border-b border-[#E9EAF0] pb-4">
                    {creatorImage ? (
                      <img
                        src={creatorImage}
                        alt={creatorName || "Creator"}
                        className="h-[50px] w-[50px] shrink-0 rounded-full border-2 border-white object-cover shadow-sm ring-2 ring-[#089BC4]/20"
                      />
                    ) : (
                      <div className="flex h-[50px] w-[50px] shrink-0 items-center justify-center rounded-full bg-[#089BC4]/10 text-sm font-semibold text-[#089BC4] ring-2 ring-[#089BC4]/20">
                        {creatorInitials || "?"}
                      </div>
                    )}

                    <div className="min-w-0">
                      <p className="mb-1 text-xs uppercase tracking-wide text-[#6E7485]">
                        Created by
                      </p>

                      <div className="flex flex-wrap items-center gap-2">
                        <h3 className="truncate font-medium leading-[22px] text-[#1D2026]">
                          {creatorName || "Unknown"}
                        </h3>

                        {creator?.role && (
                          <span className="rounded-full bg-[#E0F7FA] px-2.5 py-0.5 text-xs font-medium capitalize text-[#089BC4]">
                            {creator.role}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 xl:grid-cols-4 gap-4 xl:gap-6 2xl:gap-8 pt-3 px-6 xl:px-10 2xl:px-14">
                    <Stat value="3 Weeks" name="Duration" />
                    <Stat value={sessionStudents.length || 0} name={sessionStudents.length === 1 ? "Student" : "Students"} />
                    <Stat value={modules.length} name="Sessions" />
                    <Stat value={course?.courseLevel} name="  Level" />
                  </div>
                </div>
              </div>
            </div>

            {/* Course Modules */}
            <div className="bg-white border border-[#E5E7EB] rounded-xl mt-5 overflow-hidden">
              <div className="flex items-center justify-between px-6 py-4 border-b border-[#E5E7EB] bg-[#F9FAFB]">
                <h2 className="text-lg  text-[#1F2937]">Course Modules</h2>

                <p className="text-[#6B7280] text-sm pr-4">
                  {modules?.length || 0} Modules
                </p>
              </div>

              {/* Modules List */}
              <div className="pl-6 pb-7 pt-6 pr-8 space-y-6">
                {modules?.map((module, index) => (
                  <div
                    key={module?._id}
                    className="border border-[#E5E7EB] bg-[#F9FAFB] rounded-xl px-5 py-5 flex items-center gap-2"
                  >
                    <div className="w-6 h-6 rounded-full bg-[#089BC4] flex items-center justify-center text-white text-sm ">
                      {index + 1}
                    </div>

                    {/* Title + Status */}
                    <div className="flex items-center gap-2">
                      <h3 className=" text-[#000]">{module?.moduleName}</h3>

                      <span
                        className={`px-2 py-1 rounded-full text-xs  ${
                          module?.completed
                            ? "bg-[#DCFCE7] text-[#166534]"
                            : "bg-[#FEE2E2] text-[#991B1B]"
                        }`}
                      >
                        {module?.completed ? "Complete" : "Incomplete"}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-[#F4F4F4] mt-10 border-b border-[#E5E7EB] px-6 py-4">
              <p className="text-lg text-[#1F2937]">
                Total Students ({sessionStudents.length})
              </p>
            </div>
            <div className="mt-4 bg-[#F4F4F4] p-1.5 space-y-1">
              {sessionStudents.length === 0 ? (
                <div className="rounded-lg border border-dashed border-[#E5E7EB] bg-white px-6 py-10 text-center">
                  <p className="text-sm text-[#6E7485]">
                    {sessionStudentsData?.message ||
                      "No students enrolled in this course yet."}
                  </p>
                </div>
              ) : (
                sessionStudents.map((std) => {
                  const studentName = [std?.firstName, std?.lastName]
                    .filter(Boolean)
                    .join(" ");
                  const studentImage = std?.profilePicture?.secureUrl;
                  const studentInitials = [std?.firstName?.[0], std?.lastName?.[0]]
                    .filter(Boolean)
                    .join("")
                    .toUpperCase();

                  return (
                    <div
                      key={std._id}
                      className="rounded-lg border border-[#E5E7EB] bg-white p-4"
                    >
                      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                        <div className="flex min-w-0 items-center gap-3">
                          {studentImage ? (
                            <img
                              src={studentImage}
                              alt={studentName || "Student"}
                              className="h-9 w-9 shrink-0 rounded-full object-cover"
                            />
                          ) : (
                            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#089BC4]/10 text-xs font-semibold text-[#089BC4]">
                              {studentInitials || "?"}
                            </div>
                          )}

                          <div className="min-w-0">
                            <p className="truncate text-sm font-medium text-black">
                              {studentName || "Unknown Student"}
                            </p>

                            <p className="mt-1 inline-flex rounded-full bg-[#FFEDD5] px-3 py-1 text-xs font-medium text-[#9A3412]">
                              Session: {std?.modulesMarkedComplete ?? 0}/
                              {std?.totalModules ?? 0}
                            </p>
                          </div>
                        </div>

                        <button
                          type="button"
                          className="rounded-lg bg-[#089BC4] px-5 py-2 text-sm text-white"
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </>
        )}
      </div>
    </InstructorLayout>
  );
};

export default CourseDetails;
